import { Injectable } from '@angular/core';
import { EventBus } from '../event-bus';

type ExternalEvents = '[Tasks] updated' | '[Task] selected' | '[TaskCounts] updated';

/**
 * TaskEventBus is responsible for emitting and listening to task-related events across the application.
 * Provided on demand by the task provider.
 */
@Injectable()
export class TaskEventBus extends EventBus<ExternalEvents> {}
